import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AppService } from 'src/app/app.service';
import { TableService } from 'src/app/shared/services/tableService/table.service';
import { DeleteWarningComponent } from 'src/app/shared/components/delete-warning/delete-warning.component';
import { fuel_escalator_column_edit, FUEL_PRICE_TABLE_INTERFACE } from 'src/app/shared/interfaces/fuel-escalator.interface';
import { MatDialog } from '@angular/material/dialog';
import { HttpService } from 'src/app/shared/services/http.service';
import { FUEL_PRICE_RATE_COLUMN_LIST } from 'src/app/shared/constants/fuel-escalator.constant';
import { ImportDialogComponent } from 'src/app/shared/components/import-dialog/import-dialog.component';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { Router } from '@angular/router';
import { WarningCalculationComponent } from 'src/app/shared/components/warning-calculation/warning-calculation.component';
import { FileErrorPopupComponent } from 'src/app/shared/components/file-error-popup/file-error-popup.component';
import { take } from 'rxjs';
import { UnsavedAlertComponent } from 'src/app/shared/components/unsaved-alert/unsaved-alert.component';

@Component({
  selector: 'app-edit-fuel-escalator',
  standalone: false,
  templateUrl: './edit-fuel-escalator.component.html',
  styleUrl: './edit-fuel-escalator.component.scss'
})
export class EditFuelEscalatorComponent implements OnInit, AfterViewInit{
  public escalatorForm:FormGroup;
  public contactTableForm:FormGroup = new FormGroup({});

  totalRecord = 200
  currentRecord = 10
  currentPage = 1;
  pageSize: number = 5;
  goToPageNumber: number  = 1;
  displayedColumns: any=FUEL_PRICE_RATE_COLUMN_LIST
  allSelected= false;
  dataSource:any = new MatTableDataSource<FUEL_PRICE_TABLE_INTERFACE>();
  dataPriceSource:any;

  @ViewChild(MatSort) sort: MatSort | any;
  @ViewChild(MatPaginator) paginator: MatPaginator | any;
  filteredValues:any = { topFilter: false };
  public operation = "add";
  userData:any;
  searchItems: any = [];
  fuelCreatedResp: any;
  countryListArr: any;
  dataColList:any;
  actualData:any;
  includeTAxARR = [{label:'No', id:0},{label: 'Yes', id:1}]
  dialogRef: any;
  minDate:any;
  importSub:any;
  isValuesChanged:boolean = false;

  constructor(private fb: FormBuilder,public appService:AppService, private excelService:ExcelService,
    public tableService:TableService,private dialog:MatDialog,private httpService:HttpService, private router:Router) { 
    this.escalatorForm = new FormGroup({
      description: new FormControl('', Validators.required),
      effectiveDate: new FormControl('', [Validators.required, this.minDateValidator]),
      createdDate: new FormControl(''),
      createdBy: new FormControl(''),
      modifiedBy: new FormControl(''),
      modifiedDate: new FormControl(''),
    });

    let userData = sessionStorage.getItem("user-data");
    this.userData = userData?JSON.parse(userData):null;
    this.dataPriceSource = (history.state).data;
    this.operation = (history.state).operation;
    this.minDate =new Date();
    // this.appService.onDateFromTimeZone
    
    if(this.userData.RoleID !=4){
      this.operation = 'view'
    }
    // if(this.operation !== "add"){
      this.tableService.tableDataGetList('fuel-price',this);
    // }
    this.getCountryList();
    this.toUpdateOnField();
    
    this.dataColList = this.tableService.getTableColNames(this.displayedColumns)
    this.contactTableForm = new FormGroup({
      CountryofFuelIndexFilter: new FormControl('', Validators.required),
      IncludeTaxFilter: new FormControl('', Validators.required),
      EscalatorValueFilter: new FormControl('', Validators.required),
    });

    setTimeout(() => {
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.tableService.checkWithFilter(this);
    },0);    
  }

  onbackCall(){
    if(this.isValuesChanged){
      const dialogRef = this.dialog.open(UnsavedAlertComponent, {
              disableClose: false,
            });
            dialogRef.afterClosed().subscribe((evt:any) => {
              if(evt.operation === "confirm"){
                this.router.navigateByUrl('/home/fuel-escalator')
              }
            })
    }
    else{
      this.router.navigateByUrl('/home/fuel-escalator')
    }
    
  }

  OnErrorFile(title:string,msg:string){
    // this.importSub.unsubscribe();
    // if (!this.dialogRef) {
      let dialogRef = this.dialog.open(FileErrorPopupComponent, {
        disableClose: false,
        data:{
          title:title,
          message:msg
        }
      });
      
      dialogRef.afterClosed().subscribe((evt:any) => {        
        if(evt?.operation === 'try'){
          // this.dialogRef.close();
          this.onImportData();
        }
      })
    }


  getPageCount(): number {
    return Math.ceil(this.dataSource.data.length / this.pageSize);
  }

  minDateValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const selectedDate = new Date(control.value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (selectedDate < today) {
      return { 'minDate': true };
    }
    return null;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.pageSize = this.tableService.editfuelEsltrPageCount;
    this.isValuesChanged = false;
    Object.keys(this.escalatorForm.controls).forEach(controlName => {
      this.escalatorForm.get(controlName)!.valueChanges.subscribe((value:any) => {
        this.isValuesChanged = true;
      });
    });
  }
 
  onKeyDownOnTable(event: KeyboardEvent) {
   if(this.operation ==="add"){
    return;
   }
    
    if((this.operation === 'view' || (this.dataPriceSource.Status === "Calculated"))){
    event.preventDefault();
    }
  }

  findCountryName (i:number){
    return this.countryListArr?.find((item:any)=>item.CountryID === i)?.CountryName;
  }

  toUpdateOnField() {
    this.minDate =new Date();
    this.escalatorForm.enable();
    this.contactTableForm.enable();
    if (this.operation === 'add') {
      this.escalatorForm.patchValue({
        createdBy:  (this.userData.Email).includes('dhl')?'LLP User':this.userData.Email,
        createdDate: this.appService.getWithFormatToday(),
        modifiedDate: '',//this.appService.getWithFormatToday(),
        modifiedBy:  ''//(this.userData.Email).includes('dhl')?'LLP User':this.userData.Email
      })
      return;
    }
    if (this.operation === 'view' || this.dataPriceSource.Status === "Calculated") {
      this.escalatorForm.disable();
      this.contactTableForm.disable();
    }
    
    this.escalatorForm.patchValue({
      effectiveDate: new Date(this.dataPriceSource.FuelEscalatorEffectiveDate),
      description: this.dataPriceSource.FuelEscalatorDescription?this.dataPriceSource.FuelEscalatorDescription:"",  
      createdDate: this.tableService.checkOnInvalidDate(this.dataPriceSource.CreatedOn),
      modifiedDate: this.tableService.checkOnInvalidDate(this.dataPriceSource.ModifiedOn),
      createdBy: this.dataPriceSource.CreatedBy,
      modifiedBy: this.dataPriceSource.ModifiedBy
    })
    
  }

  onDaetChange(e:any,name:string){
    this.minDate =new Date();
    if(e.value){
      this.escalatorForm.get('effectiveDate')?.setValue(e.value)
    }    
  }

  add(event: any): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.searchItems.push({ name: value.trim() });
    }
    if (input) {
      input.value = '';
    }
  }
  remove(item: any): void {
    const index = this.searchItems.indexOf(item);
    if (index >= 0) {
      this.searchItems.splice(index, 1);
    }
  }
  onKeyDown(event: KeyboardEvent, condition=false) {
    if(condition)
      return;
      event.preventDefault();
  }

  getCountryList() {
    this.appService.isLoading = true;
    this.httpService.getCountryList()
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        if (res) {
          this.countryListArr = res
          this.countryListArr.sort((a:any, b:any) => ((a.CountryName).toLowerCase() > (b.CountryName).toLowerCase()) ? 1 : -1);  
        }
      })
  }

  getCurrentRecordCount(): number {
    let val = this.paginator ? this.paginator?.pageIndex + 1 : 0;
    if(val*this.pageSize > this.dataSource.data.length){
      return this.dataSource.data.length%this.pageSize;
    }
    return this.pageSize;
  }

  onTabKey(event: KeyboardEvent) {
    event.preventDefault();
  }

  onCheckValue(e:any,ele:any,order:any, iterable:any){
    this.isValuesChanged = true;
    if(ele === 'CountryofFuelIndex'){
      this.dataSource.data[order]['CountryID']=Number(e.value);
      this.dataSource.data[order]['OriginCountry']=this.countryListArr.find((i:any)=>i.CountryID === Number(e.value)).CountryName;  
      return;
    }
    this.dataSource.data.find((dat:any)=>dat.CountryID === iterable.CountryID)[ele]=e.value;
  }
  
  isDuplicated(excelData:any) {
    // if(this.dataSource.data.length === 0){  
    //   this.OnErrorFile('File not Supported','Please upload the correct .xlsx file');
    //   return false;
    // }
    const duplicateCountryIDs = excelData.reduce((acc:any, obj:any, index:any) => {
      if (obj.CountryID !== undefined && excelData.findIndex((item:any) => item.CountryID === obj.CountryID) !== index) {
        acc.push(obj.CountryID);
      }
      return acc;
    }, []);

    if(duplicateCountryIDs.length>0){
      this.OnErrorFile('Duplicate Countries Present','Please upload the correct .xlsx file');
      return false;
    }
      

    let find = excelData.find((i:any) => i.CountryID === undefined)
    if(find){
      this.OnErrorFile('Incorrect Countries Present','Please upload the correct .xlsx file');
      return false;
    }
    return true;
    // for excatly matching with daatsource country and excel country
    // return excelData.map((data:any)=>data.CountryID).sort((a: number,b: number)=>a-b).join('') === this.dataSource.data.map((data:any)=>data.CountryID).sort((a: number,b: number)=>a-b).join('')
  }

  onDelete(){
    if(this.operation === 'view'){
      return;
    }
    this.tableService.deleteItem('FuelEscalator', 'FuelEscalatorID',this.dataPriceSource.FuelEscalatorID	,this);
  }
  onUpdateRate(){
    if(this.dataPriceSource.Status === "Calculated"){
      this.escalatorForm.disable();
      this.contactTableForm.disable();
      return;
    }
    const dialogRef = this.dialog.open(WarningCalculationComponent, {
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((evt:any) => {
      if(evt.operation === "save"){
        this.appService.isLoading = true;
        let body = {
          FuelEscalatorID:this.dataPriceSource.FuelEscalatorID,
          UserEmail:this.userData.Email
        }
        this.httpService.toCalculateFuelPrice(body)
        .subscribe((res:any) =>{
          this.appService.isLoading = false;
          this.httpService.openSnackBar('Rate Calculated Successfully')
          this.router.navigateByUrl("/home/fuel-escalator")
        })
      }
    })
  }
  onSave(){
    if (this.operation === 'view') {
      return;
    }
    if (this.escalatorForm.invalid) {
      this.httpService.openSnackBar('Please fill all the required Field')
      return;
    }
    
    if(this.dataSource?.data.some((item:any)=>item.CountryID === 0)){
      this.httpService.openSnackBar('Please Choose Country Origin')
      return;
    }
    if(this.dataSource?.data.length ===0){
      this.httpService.openSnackBar('Please Add Atleast One Country Origin')
      return;
    }
    const duplicateCountryIDs = this.dataSource.data.reduce((acc:any, obj:any, index:any) => {
      if (obj.CountryID !== 0 && this.dataSource.data.findIndex((item:any) => item.CountryID === obj.CountryID) !== index) {
        acc.push(obj.CountryID);
      }
      return acc;
    }, []);

    if(duplicateCountryIDs.length>0){
      this.httpService.openSnackBar('Country Origin value is duplicated!')
      return;
    }
    
    let session =sessionStorage.getItem("fuel-data");
    let fuelData = session?JSON.parse(session):null;
    let selectedDate:any = this.appService.dateFormate(this.escalatorForm.get('effectiveDate')?.value)
    let changeVal = selectedDate.split('-').reverse().join('/');
    
    // let isExist = fuelData?.find((i:any)=>this.appService.onDateFromTimeZone(i.FuelEscalatorEffectiveDate) === changeVal);
      // if(isExist){
      //   this.httpService.openSnackBar('The Fuel Escalator on this date is already exists');
      //   return;
      // }
  
    let body = {
      "FuelEscalatorID":this.operation === 'add' ?null:this.dataPriceSource.FuelEscalatorID,
      "EffectiveDate": this.appService.dateFormate(this.escalatorForm.get('effectiveDate')?.value),	
      "FuelEscalatorDescription":this.escalatorForm.get('description')?.value,	
      "UserEmail":this.userData.Email	
    }

    this.appService.isLoading = true;
    this.httpService.setEscalatorDetails(body)
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        if (res) {
          if(res[0].DuplicateFlag === 1){
             this.httpService.openSnackBar(res[0].MSG);
             return;
          }
         
          this.fuelCreatedResp = this.operation==="add"?res[0].FuelEscalatorID:0;
          this.setFuelPriceList();
        }
      })
  }

  compareDates(date1:any, date2:any) {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return d1.getUTCFullYear() === d2.getUTCFullYear() &&
           d1.getUTCMonth() === d2.getUTCMonth() &&
           d1.getUTCDate() === d2.getUTCDate();
  }

  setFuelPriceList(){
    this.dataSource.data = this.dataSource?.data.map((item:any)=>{return {...item, Selected:false,UserEmail:this.userData.Email }});
    if(this.operation === 'add'){
    this.dataSource.data.forEach((item:any)=>{item.FuelEscalatorID = this.fuelCreatedResp});
    }
    
    let output = this.dataSource.data.map((item:any) => ({
      ...item, IncludeTax: item.IncludeTax === "Yes"?1:0,
    }));
    this.appService.isLoading = true;
    this.httpService.setPriceCountry(output)
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        if (res) {
          this.router.navigateByUrl('/home/fuel-escalator')
          this.httpService.openSnackBar('Fuel Escalator Details Updated Successfully')
        }
      })
  }

  onOptionChange(option:string){

  }

  onDeleteRow(){
    this.allSelected = false;
    const dialogRef = this.dialog.open(DeleteWarningComponent, {
      disableClose: false,
      data: { header: "Delete Fuel Price", msg: "Are you sure you want to delete Index of Fuel Price?" }
    });
    dialogRef.afterClosed().subscribe((evt:any) => {
      if(evt.operation === "confirm"){
        this.isValuesChanged = true;
        this.dataSource.data = this.dataSource.data.filter((item:any)=>!item.Selected);
        this.dataSource = new MatTableDataSource<FUEL_PRICE_TABLE_INTERFACE>(this.dataSource.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.tableService.checkWithFilter(this);
      }
    })
  }
  onAddNewRow(){
    this.isValuesChanged = true;
    if(this.dataSource?.data.length === 0){
      this.dataSource = new MatTableDataSource<FUEL_PRICE_TABLE_INTERFACE>([]);
      this.dataSource.data.unshift({
        FuelEscalatorID: this.operation==="add"?0:this.dataPriceSource.FuelEscalatorID,CountryID: 0,IncludeTax: "No",EscalatorValue: 0,
        Selected:false, UserEmail:this.userData.Email
      });
      this.dataSource.data = [...this.dataSource.data];
      return;
    }

    this.dataSource.data.unshift({
       FuelEscalatorID: this.operation==="add"?0:this.dataPriceSource.FuelEscalatorID,CountryID: 0,IncludeTax: "No"
       ,EscalatorValue: 0,
      Selected:false, UserEmail:this.userData.Email
    });
    this.dataSource.data = [...this.dataSource.data];
  }
  onExportdata(){
    const exportData= this.dataSource.data.filter((data:any)=>data.Selected).map((item:any) => ({
      ...item,
      
      IncludeTax: item.IncludeTax,
      // FuelEscalatorEffectiveDate: this.appService.excelDateFormate(item.FuelEscalatorEffectiveDate),
      ...this.dataPriceSource
    }));
    this.tableService.exportToExcel(exportData, fuel_escalator_column_edit , 'EditFuelEscalatorTable');
  }
  onImportData(){
    const dialogRef = this.dialog.open(ImportDialogComponent, {
      disableClose: false,
      data: { screen: "fuel-escalator" }
    });
    this.importSub =this.excelService.fileDataEmitter.subscribe((evt:any)=>{
      if(evt === "fuel-escalator"){
        this.isValuesChanged = true;
        let excelData:any
        if(this.excelService.data.length>0){
          excelData= this.excelService.data.map((item:any)=>{
            return{
            'FuelEscalatorID': this.operation==="add"? 0:this.dataPriceSource.FuelEscalatorID,
            "CountryID": this.countryListArr.find((i:any)=>(i.CountryName)?.toLowerCase() === (item.Country)?.toLowerCase())?.CountryID,
            'IncludeTax': item["Including Taxes"]==='Y'?'Yes':'No',
            'EscalatorValue': item['Index Value']!=null?item['Index Value']:0,
            'Selected':false,
            'UserEmail':this.userData.Email
            }
           
          }); 
        }
        else{
          this.OnErrorFile('File not Supported','Please upload the correct .xlsx file');
          return;
        }

        // let excelFirstVal:any;
        
        // if(!excelFirstVal){
        //   this.OnErrorFile();
        //   return;
        // }
        // const hasValue = excelFirstVal.hasOwnProperty("Including Taxes") && excelFirstVal.hasOwnProperty("Index Value");        
       
        // if(!hasValue){
        //   this.OnErrorFile();
        //   return;        
        //   }
          
        if(this.isDuplicated(excelData)){
          this.dataSource.data = [ ...excelData];// only excel data will be heres
          this.dataSource = new MatTableDataSource<FUEL_PRICE_TABLE_INTERFACE>(this.dataSource.data);
          this.tableService.checkWithFilter(this);
        }
        else{
          // this.OnErrorFile();
          return;
        }
        
        setTimeout(() => {
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.tableService.checkWithFilter(this);
          
        },0);
      }
    });
    dialogRef.afterClosed().subscribe(evt => {
      this.importSub.unsubscribe();
    })
  }
  
}

